import { StringDict } from "@azure/msal-common";
import { BaseService } from "./base.service";
import { IPublicClientApplication } from "@azure/msal-browser";

export class RecordingService extends BaseService {
  constructor(instance: IPublicClientApplication) {
    super(instance);
  }

  public async startRecording(
    meetingId: string,
    studentId: number,
    examId: number
  ): Promise<any> {
    // Original
    // var options = this.getHeaderOption("GET");
    // const response = await fetch(`${this.getEndPoint()}/recording/startRecording?meetingID=${meetingId}&StudentID=${studentId}&ExamID=${examId}`, options);

    // Mew Refetch Token
    const url = `${this.getEndPoint()}/recording/startRecording?meetingID=${meetingId}&StudentID=${studentId}&ExamID=${examId}`;
    const method = "GET";

    const response = await this.getHeaderOptionWithToken(url, method);

    if (response.ok) {
      const responseAsJson = await response.json();
      return responseAsJson;
    }
    throw "Invalid recording response";
  }

  public async stopRecording(
    meetingId: string,
    studentId: number,
    examinationId: number,
    recordingId: string,
    attendentsId: number
  ): Promise<any> {
    // Original
    // var options = this.getHeaderOption("GET");
    // const response = await fetch(
    //   `${this.getEndPoint()}/recording/stopRecording?meetingID=${meetingId}&StudentID=${studentId}&ExaminationId=${examinationId}&recordingId=${recordingId}&AttendentsId=${attendentsId}`,
    //   options
    // );

    // Mew Refetch Token
    const url = `${this.getEndPoint()}/recording/stopRecording?meetingID=${meetingId}&StudentID=${studentId}&ExaminationId=${examinationId}&recordingId=${recordingId}&AttendentsId=${attendentsId}`;
    const method = "GET";

    const response = await this.getHeaderOptionWithToken(url, method);

    if (response.ok) {
      return response;
    }
    throw "Invalid recording response";
  }
}
